export default __webpack_public_path__ + "static/media/PROGRAMME-01-01.53ab86ea.png";